/* eslint-disable @typescript-eslint/no-unsafe-return */
function isPlainObject(value: unknown): value is Record<string, unknown> {
  if (value === null || typeof value !== 'object') {
    return false;
  }
  if (Object.prototype.toString.call(value) !== '[object Object]') {
    return false;
  }
  const proto = Object.getPrototypeOf(value);
  return proto === null || proto === Object.prototype;
}

/**
 * Recorre objetos y arrays y aplica String.prototype.trim a todos los strings.
 * Útil para normalizar valores de formularios antes de enviarlos al backend.
 */
// eslint-disable-next-line import/prefer-default-export
export function trimFormValues<T>(input: T): T {
  if (input === null || input === undefined) {
    return input;
  }
  if (typeof input === 'string') {
    return input.trim() as unknown as T;
  }
  if (Array.isArray(input)) {
    return input.map((item) => trimFormValues(item)) as unknown as T;
  }
  if (isPlainObject(input)) {
    const out: Record<string, unknown> = {};
    const record = input as Record<string, unknown>;
    Object.keys(record).forEach((key) => {
      out[key] = trimFormValues(record[key]);
    });
    return out as T;
  }
  return input;
}
